/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import * as ArrayUtil from 'fierry/util/array';


export default class SectorUsers extends Logic
{
  getCurrentWinner ()
  {
    const distribution = new Map();

    for (const zone of this.object.getZones().values())
    {
      distribution.set(zone.cass.currentUser, (distribution.get(zone.cass.currentUser) ?? 0) + 1);
    }

    return ArrayUtil.findMax([ ...distribution.keys() ].sort(), user => distribution.get(user));
  }


};
